export class Role {

    Id :number;
    code: string;
    Name :string;
    Remarks:string;
    EmployeeId: number;
    EmployeeBranchId: number;
    CompanyId: number;
    SaasId: string;
    CreatedDate: Date;
    ModifiedDate: Date;
    IsActive  : boolean;
    Flag : number;
}

